/**
 * Default options.
 *
 * @property wrap - Should tabs wrap when on the first/last tab.
 * @property orientation - Tab orientation.
 * @property selected - Initial selected tab.
 * @property selectedTabClass - Class added to selected tabs.
 * @property initialisedClass - Class added on initialisation.
 * @property selectedPanelClass - Class addded to selected tab panel.
 * @property eventTypePrefix - String that should be prefixed to event names.
 */
const options = {
	wrap: true,
	selected: 0,
	eventTypePrefix: '',
	orientation: 'horizontal',
	initialisedClass: 'tabs--initialised',
	selectedPanelClass: 'tab-panel--selected',
	selectedTabClass: 'tab--selected',
};

export default options;
